'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _path = require('path');

exports.default = function (source, opts, config) {
	if (!source || !opts || !config) {
		return undefined;
	}

	if (opts.forceFullURL && !opts.location) {
		throw new Error('opts.location is required when using forceFullURL');
	}

	if (source.startsWith('http://') || source.startsWith('https://')) {
		return source;
	}

	if (source.startsWith('data:image/svg')) {
		return source;
	}

	if (config.mediaServiceBaseURL) {
		return config.mediaServiceBaseURL + '/' + (opts.scale || 'original') + '/' + source;
	}

	if (config.mediaPath) {
		var prefix = opts.forceFullURL ? opts.location : '';

		if (!opts.scale || opts.scale === 'original') {
			return '' + prefix + config.mediaPath + '/' + source;
		}

		var extension = (0, _path.extname)(source);
		var base = (0, _path.basename)(source, extension);

		return '' + prefix + config.mediaPath + '/' + base + '_' + opts.scale + extension;
	}

	return '';
};